import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';
import SearchSelect from '../../../../../components/Select/SearchSelect';

const AddPaymentModal = ({ open, error, isLoading, isLoadingSubmit, methods, onHide, onShow, onSubmit }) => {
  const formNode = useRef(null);

  const [modalError, setError] = useState(error);
  const [selectedMethod, setSelectedMethod] = useState(null);

  const onSubmitForm = () => {
    onSubmit?.('add', selectedMethod?.id);
  };

  const onShowModal = () => {
    setError('');
    onShow?.();
  };

  useEffect(() => {
    setError(error);
  }, [error]);

  return (
    <Modal show={open} onHide={onHide} onShow={onShowModal} backdrop="static" className="modal-md-custom">
      {isLoading && <div className="modal-loader-small" />}
      <Modal.Header closeButton>
        <Modal.Title>Add payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modalError && <Alert text={modalError} />}

        <form ref={formNode}>
          <FormGroup>
            <SearchSelect
              onSelect={(value) => setSelectedMethod(value)}
              options={methods}
              listMaxHeight={390}
              toggleText="Choose method"
              label="Payment method"
              name="method"
              preselectFirst
              grouped
            />
          </FormGroup>
        </form>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit} onClick={onSubmitForm}>
          {isLoadingSubmit && <Spinner />}
          <span>Add method</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AddPaymentModal.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  methods: PropTypes.array,
  onHide: PropTypes.func,
  onShow: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddPaymentModal;
